import { render, staticRenderFns } from "./MandateDashboard.vue?vue&type=template&id=037988e8&scoped=true&"
import script from "./MandateDashboard.vue?vue&type=script&lang=js&"
export * from "./MandateDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MandateDashboard.vue?vue&type=style&index=0&id=037988e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037988e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('037988e8')) {
      api.createRecord('037988e8', component.options)
    } else {
      api.reload('037988e8', component.options)
    }
    module.hot.accept("./MandateDashboard.vue?vue&type=template&id=037988e8&scoped=true&", function () {
      api.rerender('037988e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/MandateDashboard.vue"
export default component.exports